import { success, failure, request } from 'app/actions';
import * as actions from './editClassActions';
import * as helpers from './editClassHelpers';

const initialState = {
  group: {},
  students: [],
  schoolOptions: [],
  levelOptions: [],
  periodOptions: [],
  classOptions: [],
  errors: {},
  errorDeleteStudent: '',
  groups: [],
  isLoadingGroupInformation: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.NEW_GROUP:
      return {
        ...state,
        group: initialState.group,
        students: initialState.students,
        errors: initialState.errors,
      };
    case success(actions.GET_SCHOOLS):
      return { ...state, schoolOptions: helpers.getSchoolOptions(action.payload.content) };
    case success(actions.GET_LEVELS):
      return {
        ...state,
        levelOptions: helpers.getLevelOptions(action.payload.contents, state.group),
      };
    case success(actions.GET_CLASSES):
      return {
        ...state,
        classOptions: helpers.getClassOptions(action.payload.contents, state.group),
      };
    case request(actions.GET_GROUP_INFORMATION):
      return {
        ...state,
        group: initialState.group,
        students: initialState.students,
        isLoadingGroupInformation: true,
      };
    case actions.REQUEST_VIEW_STUDENT:
      return {
        ...state,
        student: { ...action.payload },
      };
    case actions.REQUEST_EDIT_STUDENT:
      return {
        ...state,
        student: { ...action.payload },
        errors: { ...state.errors, edit: initialState.errors.edit },
      };
    case failure(actions.ADD_STUDENT):
      return { ...state, errors: { edit: action.payload.error } };
    case failure(actions.EDIT_STUDENT):
      return { ...state, errors: { edit: action.payload.error } };
    case success(actions.DELETE_STUDENT):
      const students = state.students.map((student) => {
        if (student.id === action.meta.idStudent) {
          return { ...student, deleted: true };
        }
        return student;
      });
      return { ...state, students };
    case failure(actions.DELETE_STUDENT):
      return {
        ...state,
        errorDeleteStudent: action.payload.error,
      };
    case success(actions.GET_GROUP_INFORMATION):
      return {
        ...state,
        group: action.payload.content,
        students: action.payload.content.students || [],
        isLoadingGroupInformation: false,
      };
    case failure(actions.GET_GROUP_INFORMATION):
      return { ...state, isLoadingGroupInformation: false };
    case success(actions.GET_PERIODS):
      return { ...state, periodOptions: helpers.getPeriodOptions(action.payload.content) };

    case success(actions.GET_GROUPS):
      return {
        ...state,
        groups: action.payload.content,
      };
    default:
      return state;
  }
};

export default reducer;
